import React from 'react';
import PropTypes from 'prop-types';
import SpinLoader from '../Loaders/SpinLoader';

const Icon = ({ name, size, fill, classes, loading }) => {
  let icon;
  if (loading === true) {
    icon = (
      <div className="icon icon--loader">
        <SpinLoader size={size} dark />
      </div>
    );
  } else {
    icon = (
      <svg className={`icon icon--${size} icon--fill-${fill} ${classes}`}>
        <use xlinkHref={`#icon-${name}`} />
      </svg>
    );
  }

  return icon;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  fill: PropTypes.string,
  classes: PropTypes.string,
  loading: PropTypes.bool,
};

export default Icon;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/Icon.js